import { TICKER } from "../../../mocks/chigua";

export default function TickerBand() {
  const row = [...TICKER, ...TICKER];
  return (
    <div className="border-y border-background-950/10 bg-accent-100/70 overflow-hidden">
      <div className="relative flex items-stretch">
        <span className="relative z-10 inline-flex items-center gap-2 bg-primary-600 text-background-50 px-4 md:px-6 text-xs md:text-sm font-semibold tracking-wider whitespace-nowrap">
          <i className="ri-megaphone-line" /> 神评论滚动
        </span>
        <div className="relative flex-1 overflow-hidden py-3 flex items-center">
          <div className="flex w-max animate-cg-ticker items-center gap-10">
            {row.map((t, i) => (
              <span key={i} className="inline-flex items-center gap-3 text-sm text-foreground-800 whitespace-nowrap">
                <i className="ri-quote-text text-primary-600" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}